(function () {
    'use strict';

    angular.module('UndergroundWebApp').factory('batteryTypeService', batteryTypeService);

    batteryTypeService.$inject = ['$q', '$http'];

    function batteryTypeService($q, $http) {
        var service = {
            getBatteryTypes: getBatteryTypes,
            addBatteryType: addBatteryType,
            updateBatteryType: updateBatteryType,
        };

        return service;

        function getBatteryTypes() {
            var deferred = $q.defer();

            $http.get('api/batteryType').then(result => {
                if (result && result.data) {
                    deferred.resolve(result.data);
                } else {
                    deferred.reject();
                }
            },
            function (result) {
                deferred.reject(result.data);
            }
        );
        return deferred.promise;
        }

        function addBatteryType(batteryType) {
            var deferred = $q.defer();

            $http.post("api/batteryType", batteryType).then(
                function (result) {
                    if (result && result.data) {
                        deferred.resolve(result.data);
                    } else {
                        deferred.reject();
                    }
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function updateBatteryType(batteryType) {
            var deferred = $q.defer();

            $http.put("api/batteryType", batteryType).then(
                function (result) {
                    if (result && result.data) {
                        deferred.resolve(result.data);
                    } else {
                        deferred.reject();
                    }
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }
    }
})();